// src/components/SignOut.js
import React from "react";
import { auth } from "../services/firebase";

const SignOut = () => {
    const signOut = async () => {
        try {
            await auth.signOut();
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <div>
            <button onClick={signOut}>Sign Out</button>
        </div>
    );
};

export default SignOut;
